import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Form } from 'react-bootstrap';
import { ArrowRightIcon, ArrowDownIcon } from '../../../assets/icons';
import './expandable-row.scss';

const ExpandableRowNew = ({
  pageIdentifier,
  type,
  data,
  selectedData,
  showTab,
  setShowTab,
  table,
  onSelectAll,
  keyFunction,
  projectsCount,
  labels
}) => {
  const [isIndeterminate, setIsIndeterminate] = useState(false);

  useEffect(() => {
    let filteredselectedData = data.filter((entry) => {
      return selectedData.includes(keyFunction(entry));
    });
    let checkboxElement = document.getElementById(
      `${pageIdentifier}-table-checkbox-${type}`
    );

    if (filteredselectedData.length < data.length && filteredselectedData.length !== 0) {
      checkboxElement.indeterminate = true;
      checkboxElement.checked = false;
      setIsIndeterminate(true);
    } else if (filteredselectedData.length === data.length && filteredselectedData.length !== 0) {
      checkboxElement.checked = true;
      checkboxElement.indeterminate = false;
      setIsIndeterminate(false);
    } else {
      checkboxElement.indeterminate = false;
      setIsIndeterminate(false);
    }
  }, [selectedData]);

  const setTabTitle = (tab) => {
    if (tab === "actionable") {
      return "Action Required";
    } else if (tab === "nonActionable") {
      return "No Action Required";
    } else {
      return tab.toLowerCase();
    }
  };

  const handleCheckboxClick = (e) => {
    e.cancelBubble = true;
    if (e.stopPropagation) e.stopPropagation();
    onSelectAll(e, type, isIndeterminate);
  };

  return (
    <tr
      className={`tab-row tab-row-${pageIdentifier}`}
      onClick={() => setShowTab(type)}
    >
      <td className={`tab-indicator tab-${type}`}></td>
      <td className="checkbox">
        <Form.Check
          aria-label="selectTask"
          type="checkbox"
          disabled={pageIdentifier === "task"}
          onClick={handleCheckboxClick}
          id={`${pageIdentifier}-table-checkbox-${type}`}
        />
      </td>
      <td className={`tab-title tab-${type} flex-grow-1`}>
        {setTabTitle(type)}
        <span>
          {data.length} {table == "project" ? (data.length > 1 ? labels?.ProjectPlural ?? "Projects" : labels?.ProjectSingular ?? "Project") : table}
        </span>
      </td>
      <td className="tab-row-arrow">
        <img src={showTab === true ? ArrowDownIcon : ArrowRightIcon} alt="Expand arrow" />
      </td>
    </tr>
  );
};

ExpandableRowNew.propTypes = {
  pageIdentifier: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  selectedData: PropTypes.array.isRequired,
  showTab: PropTypes.bool.isRequired,
  setShowTab: PropTypes.func,
  table: PropTypes.any,
  onSelectAll: PropTypes.func,
  keyFunction: PropTypes.func,
  projectsCount: PropTypes.shape({
    all: PropTypes.number,
    active: PropTypes.number,
    archived: PropTypes.number,
    completed: PropTypes.number
  }),
  labels: PropTypes.shape({
      ProjectSingular: PropTypes.string,
      ProjectPlural: PropTypes.string,
      ProjectSingularPossessive: PropTypes.string,
      ProjectPluralPossessive: PropTypes.string,
      TaskSingular: PropTypes.string,
      TaskPlural: PropTypes.string,
      TaskSingularPossessive: PropTypes.string,
      TaskPluralPossessive: PropTypes.string,
      FormSingular: PropTypes.string,
      FormPlural: PropTypes.string,
      FormSingularPossessive: PropTypes.string,
      FormPluralPossessive: PropTypes.string,
  }),
};

export default ExpandableRowNew;
